import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  Stack,
} from "@mui/material";
// import AppointmentForm from './GuestParticipationForm';
// import { useGuestParticipationValidation } from 'utils/validation/guest-participation-form';
// import { useYupValidationResolver } from '@qubiteq/qublib';
import CloseIcon from "@mui/icons-material/Close";

/* Wijmo Imports */

import { ModalButtons, ModalImages, useModal } from "context/modalContext";
import ButtonFreeText from "components/Buttons/ButtonFreeText";
import { format, parse } from "date-fns";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom/dist";
import "../index.css";
import ReactJson from "react-json-view";
import WijmoRowViewer from "./WijmoRowViewer";

const JsonDialog = (props) => {
  const { rowData, rowDialog, setRowData, setRowDialog } = props;
  const [data, setData] = useState(null);

  const dateFormat = (date) => {
    try {
      return format(new Date(date), "dd/MM/yyyy");
    } catch {
      return " ";
    }
  };

  const handleCancel = () => {
    setRowDialog(false);
    setRowData(null);
  };

  useEffect(() => {
    if (rowData?.type === "responseJson" || rowData?.type === "requestJson") {
      try {
        const parsedJson = JSON.parse(rowData?.data);
        setData(parsedJson);
      } catch {
        setData(rowData?.data);
      }
    }
  }, [rowData]);

  return (
    <Dialog open={rowDialog} fullWidth maxWidth="lg" sx={{ height: "99vh" }}>
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          fontWeight: "bold",
          py: 1,
          bgcolor: "#b7e0ff",
        }}
      >
        <Stack direction="column">
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            Αρχείο καταγραφής
          </Typography>
          {(rowData?.type === "responseJson" ||
            rowData?.type === "requestJson") && (
            <Typography sx={{ fontWeight: "bold" }}>
              {rowData?.type === "responseJson" ? "Απόκκριση" : "Αίτημα"}
            </Typography>
          )}
        </Stack>
        <IconButton
          sx={{ ml: "auto" }}
          aria-label="close"
          onClick={handleCancel}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {rowData?.type === "responseJson" || rowData?.type === "requestJson" ? (
          <ReactJson collapsed={2} name={rowData?.type} src={data} />
        ) : (
          <WijmoRowViewer src={rowData?.data} />
        )}
      </DialogContent>
      <DialogActions>
        <ButtonFreeText
          sx={{
            m: 1,
            background: "red",
            color: "white",
            "&:hover": {
              backgroundColor: "#8B0000",
              color: "#fefefe",
            },
          }}
          handleClick={handleCancel}
          text="ΕΞΟΔΟΣ"
        />
      </DialogActions>
    </Dialog>
  );
};

export default JsonDialog;
